module.exports = __webpack_public_path__ + "static/media/avtoControlGrid.d6b4a016.jpg";